// Device detection for WEB visitors. This is a different question from
// platform.js, which asks what shell we're running inside: Capacitor's
// getPlatform() returns 'web' in any browser, so its `isIOS` is FALSE on an
// iPhone in Safari. That module describes our app; this one describes the phone
// a website visitor is holding.
//
// It's UA sniffing, and that's not an accident — there is no standard API for
// "is this an iPhone", and navigator.userAgentData is Chromium-only, which is
// exactly the browsers we least need to identify. Kept to one file so the
// guessing is in one place and nothing else in the app grows a UA regex.
//
// Only the app-promo banner uses this. Anything about capability (plugins, API
// base, Turnstile) must keep asking platform.js instead — those depend on the
// shell, not the hardware.

const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
const platform = typeof navigator !== 'undefined' ? navigator.platform : '';
const touchPoints = typeof navigator !== 'undefined' ? navigator.maxTouchPoints || 0 : 0;

// iPadOS 13+ deliberately reports itself as MacIntel to get desktop sites, so the
// UA alone misses every iPad. The touch-points check is the standard way back.
export const isIOSWeb = /iPad|iPhone|iPod/.test(ua) || (platform === 'MacIntel' && touchPoints > 1);

export const isAndroidWeb = /Android/.test(ua);

export const isMobileWeb = isIOSWeb || isAndroidWeb;

// The in-app browsers that carry most social traffic. They render with WebKit or
// Blink but are not Safari or Chrome proper, and — the reason this file exists —
// Apple's Smart App Banner never appears in them. Someone tapping a Petzy link
// from an Instagram story is exactly who our own banner is for.
const IN_APP_BROWSER = /FBAN|FBAV|FB_IAB|Instagram|Line\/|Twitter|Snapchat|TikTok|MicroMessenger|Pinterest|LinkedIn/i;

// Non-Safari browsers on iOS. They all wrap WebKit, and none of them render
// Apple's banner either.
const OTHER_IOS_BROWSER = /CriOS|FxiOS|EdgiOS|OPiOS|YaBrowser|DuckDuckGo/i;

// Real Safari on iOS — the ONE place Apple's Smart App Banner shows up. Ours
// must stay out of its way: two stacked banners are worse than none, and Apple's
// is better (native chrome, and it says "Open" instead of "Get" when the app is
// already installed, which we cannot detect from a web page).
export const isIOSSafari = isIOSWeb
  && /Safari/.test(ua)
  && !IN_APP_BROWSER.test(ua)
  && !OTHER_IOS_BROWSER.test(ua);
